import { observable, decorate, action } from 'mobx'

class NotificationStore {
  constructor () {
    this.notificationData = {
      title: null,
      message: null,
      level: null,
      position: null
    }
  }

  sendErrorNotification (title, message) {
    this.setNotification(title, message, 'error')
  };

  sendSuccessNotification (title, message) {
    this.setNotification(title, message, 'success')
  };

  setNotification (title, message, level) {
    this.notificationData = {
      title: title,
      message: message,
      level: level,
      position: 'tr'
    }
  }
}

decorate(NotificationStore, {
  notificationData: observable,
  setNotification: action
})

export default NotificationStore



// WEBPACK FOOTER //
// ./src/stores/notificationStore.js